'use strict';
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  
  var _LinkedinFilled = _interopRequireDefault(require('./lib/icons/LinkedinFilled'));
  
  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
  
  var _default = _LinkedinFilled;
  exports.default = _default;
  module.exports = _default;